import { css } from 'styled-components'

export const colorPallet = {
  primary: '#3e9f26',
}
export const primaryColor = {
  color: css`
    color: #3e9f26;
  `,
  backgrond: css`
    background: #3e9f26;
  `,
  border: css`
    border: 1px solid #3e9f26;
  `,
}
